import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons';
import api from '../api';

function LoginPage() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [captcha, setCaptcha] = useState({ token: '', image: '' });

  // 拉取图形验证码
  const loadCaptcha = async () => {
    try {
      const data = await api.get('/auth/captcha');
      setCaptcha({ token: data.captchaToken, image: data.image });
    } catch (e) {
      // 忽略拉取失败，登录时会提示
    }
  };

  useEffect(() => {
    loadCaptcha();
  }, []);

  const onFinish = async ({ phone, password, captchaCode }) => {
    if (!captchaCode) {
      setError('请输入图形验证码');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const res = await api.post('/auth/admin-login', {
        phone,
        password,
        captchaToken: captcha.token,
        captchaCode,
      });
      const token = res.token;
      localStorage.setItem('admin_token', token);
      window.location.reload();
    } catch (e) {
      setError(e.error || '登录失败');
      loadCaptcha(); // 登录失败刷新验证码
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #07C160 0%, #128C7E 100%)',
    }}>
      <Card
        style={{ width: 400, boxShadow: '0 8px 24px rgba(0,0,0,0.15)' }}
        title={
          <div style={{ textAlign: 'center', color: '#07C160', fontSize: 24, fontWeight: 'bold' }}>
            云信管理后台
          </div>
        }
      >
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          size="large"
        >
          <Form.Item name="phone" rules={[{ required: true, message: '请输入手机号或邮箱' }]}>
            <Input prefix={<UserOutlined />} placeholder="手机号或邮箱" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="密码" />
          </Form.Item>
          <Form.Item name="captchaCode" rules={[{ required: true, message: '请输入图形验证码' }]}>
            <Input
              prefix={<SafetyOutlined />}
              placeholder="图形验证码"
              suffix={
                <img
                  src={captcha.image}
                  onClick={loadCaptcha}
                  style={{ height: 36, cursor: 'pointer', borderRadius: 4 }}
                  alt="captcha"
                  title="点击刷新验证码"
                />
              }
            />
          </Form.Item>
          {error && <div style={{ color: 'red', marginBottom: 12, fontSize: 13 }}>{error}</div>}
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={loading} style={{ width: '100%', background: '#07C160' }}>
              登 录
            </Button>
          </Form.Item>
        </Form>
        <div style={{ textAlign: 'center', fontSize: 12, color: '#999' }}>
          默认账号：admin@yunxin.com / admin123
        </div>
      </Card>
    </div>
  );
}

export default LoginPage;
